import { Component } from 'react';
import Card from '../utils/Card';
import { Button, Form, NumberBox, TextBox } from 'devextreme-react';
import { Label, SimpleItem } from 'devextreme-react/form';
//import '../rah-kala/LoadOrder.css';
import { apiGetP, apiPostNoBodyP, apiPostP, setCookie } from '../../GanjiTools';
import MinimalButton from '../MinimalButton';
import { style } from 'typestyle';
//import RegisterUser from '../rah-kala/RegisterUser';
import Inline from '../Inline';
import { Options, Button as TextboxButton } from 'devextreme-react/text-box';


class ParsSamanLogon extends Component {
    state = {
        mode: 'logon',
        allRoles: [],
    }

    onSuccessLogon = user => {
        const prj = window.config.PROJECT_NAME ?? 'project';
        window.user = user;
        setCookie(`${prj}_userid`, user?.id > 0 ? user.id : '');
        setCookie(`${prj}_logonkey`, user?.logonkey ?? '');
        setCookie(`${prj}_user_fullname`, user?.fullname ?? '');

        this.props.onSuccessLogon(user);
    }

    onRegister = role => {
        window.setFullBody(
            <RegisterUser role={role}
            />
        );
    }

    onRegisterPasswordP = stUserId => new Promise((resolve, reject) => {
        if (!(stUserId > 0)) {
            reject?.('کاربر نامعتبر');
            return;
        }

        if (!(this.state.psw1.length > 0)) {
            reject?.('رمز انتخاب شده بیش از حد کوتاه است');
            return;
        }

        if (this.state.psw1 !== this.state.psw2) {
            reject?.('رمز و تکرار آن یکسان نیستند');
            return;
        }

        apiPostNoBodyP(`/api/rahKala/registerPassword?stUserId=${stUserId}&psw=${this.state.psw1}`)
            .then(res => {
                let { error } = res ?? { error: 'No response' };
                if (error?.length > 0) {
                    reject?.(error);
                    return;
                }
                resolve?.();
            })
            .catch(reject);
    });

    renderRegisterPassword = () => (
        <div dir='rtl'
            style={{ padding: '3rem', display: 'block', margin: 'auto', background: 'whitesmoke' }}
            className='loadorder-card'
        >
            <Form rtlEnabled colCount={60} width='24rem'>
                <SimpleItem colSpan={60}>
                    <Label text='رمز عبور' />
                    <TextBox placeholder='رمز عبور خود را وارد کنید' rtlEnabled={false}
                        className='mdh-left-align' mode='password'
                        value={this.state.psw1} onValueChanged={e => this.setState({ psw1: e.value })}
                    />
                </SimpleItem>
                <SimpleItem colSpan={60}>
                    <Label text='تکرار رمز عبور' />
                    <TextBox placeholder='رمز عبور خود را مجدداً وارد کنید' rtlEnabled={false}
                        className='mdh-left-align' mode='password'
                        value={this.state.psw2} onValueChanged={e => this.setState({ psw2: e.value })}
                    />
                </SimpleItem>
            </Form>
            <br />
            <MinimalButton icon={''} text='ثبت' width='100%' // type='success'
                normalBackground='forestgreen' highlightedBackground='#4c9e4c'
                normalColor='whitesmoke' highlightedColor='white'
                spacing='1rem'
                style={{ padding: '0.5rem', borderRadius: '1rem' }}
                onClick={() => this.onRegisterPasswordP(window.user?.id)
                    .then(() => {
                        this.setState({ mode: 'logon', psw1: '', psw2: '' }, () => window.notif('رمز با موفقیت تغییر یافت'));
                    })
                    .catch(window.notif)
                }
            />
        </div>
    );

    processLogonResult = (res, _role, justLogon) => {
        if (!justLogon)
            console.log("logon res = ", res);

        let { error, id = 0, logonkey = '', needs_captcha, change_password,
            fname = '', lname = '', nationalcode = '', role = '',
            linkedrecord_rowid = -1, summary = '?', all_users = []
        } = res ?? { error: 'No Response.' };

        if (_role == '<from_res>')
            _role = role;

        if (!(error?.length > 0) && _role !== role)
            error = 'نقش نادرست است';

        if (!justLogon) {
            this.state.needsCaptcha = needs_captcha;

            if (error?.length > 0) {
                this.setState({
                    captchaKeyCounter: this.state.captchaKeyCounter + 1,
                    message: error,
                    mode: 'login',
                    psw: ''
                }, () => window.notif(error));
                return;
            }
        }
        else if (error?.length > 0)
            return;

        let idAtRole = this.state.userName;

        let userName = `${role}/${this.state.userName}`;

        console.log(all_users);

        if (this.state.userName === 'admin') {
            idAtRole = '0';
            userName = `admin/${role}`;
        }

        if (!justLogon && change_password) {
            window.user = { id, logonkey, role };
            window.notif('رمز عبور باید عوض شود');
            //window.setInnerBody(<RegisterUser step='RegisterPassword' stUser={window.user} />);
            this.setState({ mode: 'change_password', psw1: '', psw2: '' });
            return;
        }
        this.onSuccessLogon({ id, logonkey, userName, role, idAtRole, fullname: `${fname ?? ''} ${lname ?? ''}`, linkedrecord_rowid, summary: summary + ` (${userName})` });
    }

    loadAllRolesP = () => new Promise((resolve, reject) => {
        apiGetP('/api/parssaman/userRoles')//'/api/logon/allRoles')
            .then(res => {
                let { error, list = [] } = res ?? { error: 'No response.' };
                if (error?.length > 0) {
                    reject?.(error);
                    return;
                }
                // list = list.map(u => ({
                //     name: u,
                //     icon: u.role === 'راننده' ? 'fa_truck-container-empty'
                //         : u.role === 'ماشین دار' ? 'fa_truck-container-empty'
                //             : u.role === 'مشتری' ? 'fa_shopping-cart'
                //                 : '' //////////////////////
                // }));
                resolve(list);
            }).catch(reject);
    });

    onLogon = _role => {
        apiPostP('/api/logon/logon', {
            userName: this.state.userName === 'admin' ? 'admin' : this.state.userName + '/role=' + _role,
            password: this.state.psw?.length > 0 ? this.state.psw : '',///////////////////////
            captcha: this.state.needsCaptcha ? this.captchaComponent?.getEnteredCode?.() : ''
        }).then(res => this.processLogonResult(res, _role, false))
            .catch(err => this.setState({ message: 'لاگین میسر نشد: ' + err }, () => console.log(err)));
    }

    onForgetPassword = () => {
        if (!(this.state.userName?.length > 0)) {
            window.notif('نام کاربری خود را وارد کنید');
            return;
        }

        apiPostP('/api/logon/resetPassword', { userName: this.state.userName, mobile: this.state.userName })
            .then(res => {
                let { error, newpsw } = res ?? { error: 'No response' };
                if (error?.length > 0) {
                    window.notif(error);
                    return;
                }
                window.notif('رمز دریافت شده از طریق پیامک را وارد کنید');
                //this.state.mode = 'pending_change_password';
                console.log(newpsw);
            })
            .catch(window.notif);
    }

    //static containerStyle0 = { display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' };
    static containerStyle = {
        display: 'flex', placeItems: 'center', height: '100vh', backgroundImage: 'url(/images/logon.jpg)',
        flexDirection: 'column', justifyContent: 'center'
    };

    componentDidMount() {
        this.loadAllRolesP()
            .then(allRoles => this.setState({ allRoles }, () =>
                apiGetP('/api/logon/currLogonInfo') // check if already logged on
                    .then(res => this.processLogonResult(res, '<from_res>', true))
                    .catch()
            )).catch(window.notif);
    }

    render() {
        if (this.state.mode === 'change_password')
            this.renderRegisterPassword();

        return (
            <div style={ParsSamanLogon.containerStyle}>
                {/* <img src='/images/company-logo.png' width='100px' alt='logo' /> */}
                <div dir='rtl' style={{
                    padding: window.mView ? '10px' : '1rem 3rem', display: 'block', margin: 'auto', background: '#ffffff7f', // 'whitesmoke',
                    color: 'black', border: !window.mView && '1px solid black', backdropFilter: 'blur(10px)'
                }}
                    className={window.mView ? style({ width: '-webkit-fill-available', overflow: 'scroll' }) : 'loadorder-card'}
                >
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginBottom: '2rem' }}>
                        <img src='/images/company-logo.png' width='100px' alt='logo'
                            onClick={() => this.props.onHomeClick?.()}
                        />
                    </div>
                    <Form rtlEnabled colCount={60} width='-webkit-fill-available' labelLocation={window.mView ? 'top' : 'left'}
                    >
                        <SimpleItem colSpan={60}>
                            <Label text='نام کاربری' />
                            <TextBox value={this.state.userName} onValueChanged={e => this.setState({ userName: e.value })}
                                rtlEnabled //className='mdh-left-align'
                                placeholder='نام کاربری خود را وارد کنید'
                            />
                        </SimpleItem>
                        <SimpleItem colSpan={60}>
                            <Label text='رمز عبور' />
                            <TextBox value={this.state.psw} onValueChanged={e => this.setState({ psw: e.value })} mode='password'
                                placeholder='رمز عبور خود را وارد کنید'
                            >
                                {/* 
                                    <TextboxButton name='forget' >
                                        <Options type='danger' text='فراموشی' rtlEnabled />
                                    </TextboxButton> 
                                    */}
                            </TextBox>
                        </SimpleItem>
                    </Form>
                    <br />
                    <div style={{ fontSize: '0.9rem', margin: '0.5rem 0' }}>
                        ورود به عنوان:
                    </div>
                    {
                        Card.renderCards(false, //'ورود به عنوان: ',
                            this.state.allRoles.map(x => ({ text: x.name, icon: x.icon, onClick: () => this.onLogon(x.name) })),
                            i => (
                                <MinimalButton icon={i.icon} text={i.text} iconType='light' iconSet='fa'
                                    iconSize='1.2em'
                                    highlightedBackground='transparent'
                                    highlightedColor='yellow'
                                    normalColor='#ffffffcc'
                                />
                            ),
                            undefined,
                            { background: 'forestgreen', padding: '0.5rem 1rem', width: window.mView ? undefined : '7rem', margin: '5px 5px' },
                            '', //style({padding: '0.7rem 1rem !important', backgroundColor: 'forestgreen !important' }),
                            { display: 'grid', gridTemplateColumns: window.mView ? 'auto' : 'auto auto auto' }
                        )
                    }

                    {false ?
                        <Inline style={{ marginTop: '3rem', fontSize: '0.9em' }}
                            farItems={[<MinimalButton text='فراموشی رمز عبور' key='forget-pass'
                                onClick={() => this.onForgetPassword()}
                            />
                            ]}
                        >
                            <div style={{ color: 'gray' }}>قبلاً ثبت نام نکرده اید؟</div>
                            <MinimalButton text='ثبت نام' style={{ margin: '0 1rem', color: 'blue' }}
                                onClick={() => this.onRegister('')}
                            />
                        </Inline>
                        :
                        <div>&nbsp;</div>
                    }
                </div>
            </div>
        );
    }
}

export default ParsSamanLogon;

/* 
{
    Card.renderCards('ثبت نام به عنوان: ',
        [
            { text: 'صاحب بار', icon: 'square-this-way-up', onClick: () => this.onRegister('orderer') },
            { text: 'راننده', icon: 'truck', onClick: () => this.onRegister('driver') },
            { text: 'شرکت', icon: 'building', onClick: () => this.onRegister('company') }
        ],
        i => (
            <MinimalButton icon={'fa-' + i.icon} text={i.text} iconType='light'
                iconSize='1.2em'
                highlightedBackground='transparent'
                highlightedColor='yellow'
                normalColor='#ffffffcc'
            />
        ),
        undefined,
        { background: 'steelblue', padding: '0.7rem 1rem' },
        //style({padding: '0.7rem 1rem !important', backgroundColor: 'forestgreen !important' }),
    )
} 
*/